import React from "react";
import { inject, observer } from "mobx-react";
import { IAppStore } from "../../../../stores/Interfaces";
import { EDIT_DECLARANT } from "../../../../constants/authorize";
import { Option } from "../../../common/forms/Interfaces";
import Select from "../../columns/select";
import { CHANGE_TABLE_CELL_EVENT } from "../../../../constants/events";
import { CERT_STATUS_VALUES, emptyOption } from "../../../../constants/values";

interface Props {
  option: string | number;
  options: Option[];
  entityKey: string;
  entityId: unknown;
  store?: IAppStore;
}

export const CERT_STATUS_CLASSNAME = {
  [CERT_STATUS_VALUES.registered]: "bg-lightgreen",
  [CERT_STATUS_VALUES.resolution]: "bg-lightsalmon",
};

const CertStatus: React.FC<Props> = ({
  option,
  entityKey,
  entityId,
  store,
  options,
}) => {
  if (store?.userStore.authorizeByPermission(EDIT_DECLARANT)) {
    return (
      <Select
        string={option}
        entityKey={entityKey}
        entityId={entityId}
        options={[emptyOption, ...options]}
        eventKey={CHANGE_TABLE_CELL_EVENT}
        className={CERT_STATUS_CLASSNAME[option] || ""}
      />
    );
  }

  return <>{option}</>;
};
export default inject("store")(observer(CertStatus));
